module.exports = __webpack_public_path__ + "img/exam-pass.28689952.png";